import axios from "axios";
import { Domain } from "../URLs/Domain";

export default axios.create({
  baseURL: Domain,
});
